import { EntryEnum } from '../../models/flow/entry-enum';

const entryValues = Object.keys(EntryEnum).map(key => EntryEnum[key as keyof typeof EntryEnum]);

export function getEntryFromUrl(url: string): EntryEnum | null {
  const parsedUrl = new URL(url);
  const operation = parsedUrl.searchParams.get('Operation') || parsedUrl.searchParams.get('operation');
  const entry = operation?.trim().toLowerCase() as EntryEnum;

  return entryValues.includes(entry) ? entry : null;
}

export function resolveEntryFromUrl(url: string): EntryEnum {
  const entry = getEntryFromUrl(url);
  if (entry) {
    return entry;
  }

  const pathname = new URL(url).pathname.toLowerCase();
  if (pathname.endsWith('/reset')) {
    return EntryEnum.IspBzkPass;
  }

  if (pathname.includes('electricity')) {
    return EntryEnum.Elct;
  }

  return EntryEnum.NewBan;
}

export function getEntryStartRoute(entry: EntryEnum): string {
  switch (entry) {
    case EntryEnum.Elct:
      return 'PurchasingProcessElectricity/PersonalInformationElectricity';
    case EntryEnum.Relocation:
      return 'PurchasingProcess/IdPhone';
    case EntryEnum.NewBan:
      return 'PurchasingProcess/PersonalInformation';
    default:
      return 'PurchasingProcess/IdentityNumber';
  }
  // TODO: add all existing query params with the route returned
}